import HttpService from "./http-service";

export default class AnnualReport extends HttpService {
  //eslint-disable-next-line  @typescript-eslint/no-explicit-any
  public async checkAnnualDownload(url: string): Promise<any> {
    await this.httpClient.get(url);
  }
}
